import { render, staticRenderFns } from "./enterpriseSupplementInfo.vue?vue&type=template&id=40c2ebb4&scoped=true&"
import script from "./enterpriseSupplementInfo.vue?vue&type=script&lang=js&"
export * from "./enterpriseSupplementInfo.vue?vue&type=script&lang=js&"
import style0 from "./enterpriseSupplementInfo.vue?vue&type=style&index=0&id=40c2ebb4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c2ebb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/ecommerce_h5_dev_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('40c2ebb4', component.options)
    } else {
      api.reload('40c2ebb4', component.options)
    }
    module.hot.accept("./enterpriseSupplementInfo.vue?vue&type=template&id=40c2ebb4&scoped=true&", function () {
      api.rerender('40c2ebb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/main/enterpriseSupplementInfo.vue"
export default component.exports